import React from "react";

const NoPlansAvailablePage = () => {
    return (
        <div
            className="no-plans-page d-flex flex-column align-items-center justify-content-center text-center"
            style={{
                minHeight: "80vh",
                padding: "50px 20px",
            }}
        >
            {/* Illustration */}
            <div style={{ marginBottom: "30px" }}>
                <svg
                    width="180"
                    height="180"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#6c757d"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12" y2="16"></line>
                </svg>
            </div>

            {/* Heading */}
            <h1 className="fw-bold mb-3" style={{ color: "#495057" }}>
                No Plans Available
            </h1>

            {/* Subtext */}
            <p
                className="text-muted mb-4"
                style={{
                    maxWidth: "450px",
                    lineHeight: "1.6",
                    fontSize: "1rem",
                    color: "#6c757d"
                }}
            >
                No subscription plans are available at the moment. <br />
                Admin hasn’t added any plans yet. <br />
                Please check back later to unlock features and access your account insights.
            </p>



            {/* Action Button */}
            <button
                className="btn btn-primary btn-lg"
                onClick={() => window.location.reload()}
                style={{ padding: "10px 30px", fontSize: "1rem" }}
            >
                Refresh Page
            </button>

            {/* Optional small note */}
            <p className="text-muted mt-4" style={{ fontSize: "0.9rem" }}>
                If you have questions, please contact our support team.
            </p>
        </div>
    );
};

export default NoPlansAvailablePage;
